import { Tab } from "@dmm-com/rocket-web-ui-library";
import { GRAVURE_SELECT_TABS } from "~/components/blocks/product/const";
import type { G_SampleMovie, Maybe } from "~/lib/graphql";
import { G_VideoContentType } from "~/lib/graphql";
import { platform } from "~/lib/navigator/user-agent";

export type VideoLegacySeasonTabTitleProps = {
  /** 現在選択中のタブの値 */
  selectedTabValue: string;
  /** タブの切り替え処理 */
  onChangeTabValue: (v: string) => void;
  /** サンプル動画の情報 */
  sampleMovie: Maybe<G_SampleMovie> | undefined;
  /** コンテンツタイプ */
  contentType: G_VideoContentType;
  /** パートの合計数 */
  totalPartLength: number;
  /** WindowsのVRスキーム起動可能なパートの合計数 */
  totalWindowsURLSchemesLength: number;
  /** iOSのVRスキーム起動可能なパートの合計数 */
  totalIosURLSchemesLength: number;
  /** AndroidのVRスキーム起動可能なパートの合計数 */
  totalAndroidURLSchemesLength: number;
  /** 視聴制限 */
  isAdultBlock: boolean;
};

/**
 * グラビア | 作品末端のTabTitle部分に関するコンポーネント
 * @param props {@link VideoLegacySeasonTabTitleProps}
 */
export const VideoLegacySeasonTabTitle = (props: VideoLegacySeasonTabTitleProps) => {
  const {
    selectedTabValue,
    onChangeTabValue,
    sampleMovie,
    contentType,
    totalPartLength,
    totalWindowsURLSchemesLength,
    totalIosURLSchemesLength,
    totalAndroidURLSchemesLength,
    isAdultBlock,
  } = props;

  const existSampleMovie = isAdultBlock && sampleMovie !== undefined && sampleMovie !== null;

  /** 2D作品の場合 && パート情報が2つ以上の場合は、パートTabを表示する */
  const existVod2dPart = isAdultBlock && contentType === G_VideoContentType.Vod_2D && totalPartLength > 1;

  /** VR作品の場合 && パート情報が1つ以上の場合は、パートTabを表示する */
  const existWindowsVodVrPart =
    isAdultBlock &&
    contentType === G_VideoContentType.VodVr &&
    platform === "Windows" &&
    totalWindowsURLSchemesLength > 0;

  const existIosVodVrPart =
    isAdultBlock && contentType === G_VideoContentType.VodVr && platform === "iOS" && totalIosURLSchemesLength > 0;

  const existAndroidVodVrPart =
    isAdultBlock &&
    contentType === G_VideoContentType.VodVr &&
    platform === "Android" &&
    totalAndroidURLSchemesLength > 0;

  const gravureContents = [
    existVod2dPart
      ? {
          tabLabel: `パート(${totalPartLength})`,
          value: GRAVURE_SELECT_TABS.PART,
        }
      : undefined,

    existWindowsVodVrPart
      ? {
          tabLabel: `パート(${totalWindowsURLSchemesLength})`,
          value: GRAVURE_SELECT_TABS.PART,
        }
      : undefined,

    existIosVodVrPart
      ? {
          tabLabel: `パート(${totalIosURLSchemesLength})`,
          value: GRAVURE_SELECT_TABS.PART,
        }
      : undefined,

    existAndroidVodVrPart
      ? {
          tabLabel: `パート(${totalAndroidURLSchemesLength})`,
          value: GRAVURE_SELECT_TABS.PART,
        }
      : undefined,

    {
      tabLabel: "作品情報",
      value: GRAVURE_SELECT_TABS.PRODUCT_INFO,
    },

    existSampleMovie
      ? {
          tabLabel: `サンプル動画`,
          value: GRAVURE_SELECT_TABS.SAMPLE_VIDEO,
        }
      : undefined,

    {
      tabLabel: "レビュー",
      value: GRAVURE_SELECT_TABS.REVIEW,
    },
  ];

  /** `undefined`を除去した配列を生成する */
  const tabOptions = gravureContents.flatMap((item) => {
    return item === undefined ? [] : [item];
  });

  return (
    <Tab
      name="GravureTabBlocks"
      selectValue={selectedTabValue}
      options={tabOptions}
      onChangeTab={(targetValue) => onChangeTabValue(targetValue)}
    />
  );
};
